import React from 'react';
import { MIcon } from '../Icon';
import { StatefulPopover } from '../Popover';
import {
	WeekdayHeaderStyles,
	DayStyles,
	DatepickerSpacingGlobal,
	DatepickerSpacingWeek,
	DatepickerMonthSelectorOption,
	DatepickerSpacingMonthSelector,
} from './styles';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { useStyletron } from '../../Themes';
import { Button } from '../Button';
import { borderRadius } from '../../Utilities/utils/Theming';
import * as meta from '../../meta-data.json';

const datepickerLiterals = {
	prevMonth: "Previous month",
	nextMonth: "Next month",
}

const MonthButtons = ({ icon, tooltip, children, ...rest }: any) => {
	return (
		<StatefulPopover triggerType="hover" content={tooltip} placement="top">
			<Button theme="tertiary-phantom" size="compact" iconBefore={icon} {...rest} />
		</StatefulPopover>
	);
};

const YearButton = ({ icon, tooltip, children, ...rest }: any) => {
	const [css]: any = useStyletron();
	return (
		<MIcon
			icon="keyboard_arrow_down"
			color="var(--epods--color-text-primary)"
			size="small"
			className={css({ marginLeft: 'var(--epods--space-inset-xs)' })}
		/>
	);
};

export const overridesShared = (props: any, dataProps: any, dataAria: any, propsRest: any) => {

	return {
		CalendarHeader: {
			style: ({ $theme }: any) => DatepickerSpacingMonthSelector($theme),
		},
		CalendarContainer: {
			style: ({ $theme }: any) => DatepickerSpacingGlobal($theme),
		},
		MonthYearSelectButton: {
			style: ({ $theme }: any) => {
				return {
					height: '26px',
					...borderRadius('var(--epods--border-radius)'),
					':focus': {
						outline: '0',
						boxShadow: '0 0 0 2px var(--epods--color-border-focus)',
					},
				};
			},
		},
		MonthYearSelectIconContainer: {
			// TODO: improve with next Icon component approach
			component: () => <YearButton />,
		},
		MonthYearSelectStatefulMenu: {
			props: {
				overrides: {
					List: {
						style: () => ({
							...borderRadius('var(--epods--border-radius)'),
							backgroundColor: 'var(--epods--color-bg-third-elevation)',
						}),
					},
					Option: {
						style: (data: any) => {
							return DatepickerMonthSelectorOption(data)
						},
					},
				},
			},
		},
		NextButton: {
			component: ({ ...args }: any) => {
				return <MonthButtons icon="navigate_next" tooltip={datepickerLiterals.nextMonth} {...args} />;
			},
		},
		PrevButton: {
			component: ({ ...args }: any) => {
				return <MonthButtons icon="navigate_before" tooltip={datepickerLiterals.prevMonth} {...args} />;
			},
		},
		WeekdayHeader: {
			style: ({ $theme }: any) => WeekdayHeaderStyles($theme),
		},
		Week: {
			style: ({ $theme }: any) => DatepickerSpacingWeek($theme),
		},
		Day: {
			style: (props: any) => {
				return DayStyles(props);
			},
		},
	};
};


export const overrides = (props: any, dataProps: any, dataAria: any, propsRest: any) => {

	return {
		Root: {
			props: {
				...{
					className: props.className,
					'data-epo': `epo-datepicker-${meta.version}`,
					part: `epo-datepicker-${meta.version}`,
					...getBaseCustomProps(props),
					...dataProps,
					...dataAria
				},
				style: {
					borderRadius: '4px',
					borderTopWidth: '1px',
					borderRightWidth: '1px',
					borderBottomWidth: '1px',
					borderLeftWidth: '1px',
					borderTopStyle: 'solid',
					borderRightStyle: 'solid',
					borderBottomStyle: 'solid',
					borderLeftStyle: 'solid',
					borderTopColor: 'var(--epods--color-border)',
					borderRightColor: 'var(--epods--color-border)',
					borderBottomColor: 'var(--epods--color-border)',
					borderLeftColor: 'var(--epods--color-border)',
				},
			},
		},
		...overridesShared
	}
}